import api from "../Config/api";

export const getOpenAdvancesByVendor = async (vendor_id) => {
  if (!vendor_id) throw new Error("Vendor ID is required");

  const res = await api.get(`/vendor/advance/?id=${vendor_id}`);
  return res.data; 
};

export const getPaymentHistoryByAdvance = async (advance_id) => {
  if (!advance_id) throw new Error("Advance ID is required");

  const res = await api.get(`/vendor/advancePayment/?id=${advance_id}`);
  return res.data; 
};
